import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import { Input } from '../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import { Box } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../utils/helpers'
import EditIcon from '@mui/icons-material/Edit'
import ButtonGroup from '@mui/material/ButtonGroup'
import Tooltip from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import Link from '@mui/material/Link'

import Stack from '@mui/material/Stack'

const typeObj = [
  { label: 'Immobilier', id: 1, cat: 'Logement' },
  { label: 'Comptes', id: 2, cat: '' },
  { label: 'Véhicules', id: 3, cat: 'Transport' },
  { label: 'Plan de maintenance', id: 4, cat: 'Entretien' },
  { label: 'Expériences pro (ParcoursPro)', id: 5, cat: 'Professionnel' },
  { label: 'Task (MesToDo)', id: 6, cat: '' },
  { label: 'Other', id: 7, cat: '' },
]
export default function EditOperationForm({ setOperations, params, operations, setSelected }) {
  const [typeObject, setTypeObject] = useState(0)

  const [open, setOpen] = useState(true)
  const [accounts, setAccounts] = useState([])
  const [types, setTypes] = useState([])
  const [file, setFile] = useState(null)
  const [immobiliers, setImmobiliers] = useState([])
  const [vehicules, setVehicules] = useState([])
  const [planMaintenance, setPlanMaintenance] = useState([])
  const [parcoursPro, setParcoursPro] = useState([])
  const [tasks, setTasks] = useState([])
  const [selectedImmobilier, setSelectedImmobilier] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [selectedVehicule, setSelectedVehicule] = useState(null)
  const [selectedPlanMaintence, setSelectedPlanMaintence] = useState(null)
  const [selectedParcoursPro, setSelectedParcoursPro] = useState(null)
  const [selectedTasks, setSelectedTasks] = useState(null)
  const [selectedtypeObj, setSelectedtypeObj] = useState(typeObj.find((e) => e.id === 7))
  const [selectedTypeDoc, setSelectedTypeDoc] = useState(null)
  const [typesTemps, setTypesTemps] = useState([])

  const t = {
    label: `${params[0].Types.Type}`,
    id: params[0].Types.id,
    cat: params[0].Types.categorie,
    domain: params[0].Types.Domains,
  }
  // id: v.id, cat: v.categorie, domain: v.Domains })

  // const a = { label: `${params[0].Affectations.NumeroCompte}`, id: params[0].Affectations.id }
  const f = params[0].Lien
  const input = styled('input')({
    display: 'none',
  })

  const handleClickOpen = () => {
    // setOpen(true)
    // fetchAccounts()
    // fetchDocumentsTypes()
  }

  useEffect(() => {
    setSelectedTypeDoc(t)

    // setFile(f)
    // document.getElementById('fileInput').value = f
    fetchAccounts()
    fetchDocumentsTypes()
    fetchImmobiliers()
    fetchVehicules()
    fetchPlanMaintenance()
    fetchParcours()
    fetchTasks()
  }, [])
  const fetchTasks = async () => {
    const { data, status } = await makeGetRequest(urls.fetchTasks + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterTasks = []
      data.forEach((v) => {
        filterTasks.push({ label: `${v.Nom}`, id: v.id })
      })
      if (params[0].TaskMesToDo) {
        const dval = filterTasks.find((e) => e.id === params[0].TaskMesToDo)
        setSelectedVehicule(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 6))
        setTypeObject(6)
        setValue('TaskMesToDo', dval)
      }
      setTasks([...filterTasks])
    }
  }
  const fetchImmobiliers = async () => {
    const url = urls.fetchImmobiliers + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterImmobiliers = []
      data.forEach((v) => {
        filterImmobiliers.push({ id: v.id, label: `${v.nom}` })
      })
      if (params[0].Immobilier) {
        const dval = filterImmobiliers.find((e) => e.id === params[0].Immobilier)
        setSelectedImmobilier(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 1))
        setTypeObject(1)
        setValue('Immobilier', dval)
      }
      setImmobiliers([...filterImmobiliers])
    }
  }
  const fetchVehicules = async () => {
    const url = urls.fetchVehicles + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterVehicules = []
      data.forEach((v) => {
        filterVehicules.push({ id: v.id, label: `${v.Name}` })
      })
      if (params[0].Vehicledata) {
        const dval = filterVehicules.find((e) => e.id === params[0].Vehicledata)
        setSelectedVehicule(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 3))
        setTypeObject(3)
        setValue('Vehicules', dval)
      }
      setVehicules([...filterVehicules])
    }
  }
  const fetchPlanMaintenance = async () => {
    const url = urls.fetchPlanMaintenances + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPlanMaintenances = []
      data.forEach((v) => {
        filterPlanMaintenances.push({ id: v.id, label: `${v.EquipementName}` })
      })
      if (params[0].PlanMaintenance) {
        const dval = filterPlanMaintenances.find((e) => e.id === params[0].PlanMaintenance)
        setSelectedVehicule(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 4))
        setTypeObject(4)
        setValue('PlanMaintenance', dval)
      }
      setPlanMaintenance([...filterPlanMaintenances])
    }
  }
  const fetchParcours = async () => {
    const url = urls.getParcoursPro + '?ParcoursType=Expérience&limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterData = []
      data.forEach((v) => {
        filterData.push({ id: v.id, label: `${v.Name}` })
      })
      if (params[0].ParcoursPro) {
        const dval = filterData.find((e) => e.id === params[0].ParcoursPro)
        setSelectedVehicule(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 5))
        setTypeObject(5)
        setValue('ParcoursPro', dval)
      }
      setParcoursPro([...filterData])
    }
  }
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: params[0].id,
      Type: t,
      Affectation: '',
      Immobilier: '',
      Vehicules: '',
      PlanMaintenance: '',
      ParcoursPro: '',
      TaskMesToDo: '',
      Nom: params[0].Nom,
      Description: params[0].Description,
      Externe: params[0].Externe,
      Datedéchéance: params[0].Datedéchéance ? convertToMuiDate(params[0].Datedéchéance) : '',
    },
  })
  const fetchAccounts = async () => {
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        filterAccounts.push({ label: `${v.NumeroCompte}`, id: v.id })
      })
      if (params[0].Affectation) {
        const dval = filterAccounts.find((e) => e.id === params[0].Affectation)
        setSelectedAccount(dval)
        setSelectedtypeObj(typeObj.find((e) => e.id === 2))
        setTypeObject(2)
        setValue('Affectation', dval)
      }
      setAccounts([...filterAccounts])
    }
  }

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id, cat: v.categorie, domain: v.Domains })
      })
      // setTypes([...filterTypes])
      setTypesTemps([...filterTypes])
    }
  }

  const handleClose = () => {
    setOpen(false)
    setFile(null)
    setSelected(false)
  }

  const onSubmit = async (data) => {
    // console.log(data)
    // return
    const formData = new FormData()
    if (file != null) formData.append('Lien', file)
    formData.append('Type', data.Type.id)
    data.Affectation && formData.append('Affectation', data.Affectation.id)
    data.Immobilier && formData.append('Immobilier', data.Immobilier.id)
    data.ParcoursPro && formData.append('ParcoursPro', data.ParcoursPro.id)
    data.PlanMaintenance && formData.append('PlanMaintenance', data.PlanMaintenance.id)
    data.TaskMesToDo && formData.append('TaskMesToDo', data.TaskMesToDo.id)
    data.Vehicules && formData.append('Vehicledata', data.Vehicules.id)
    formData.append('Nom', data.Nom)
    formData.append('Description', data.Description)
    formData.append('Externe', data.Externe)
    formData.append('Datedéchéance', data.Datedéchéance)

    const response = await makePutRequest(
      urls.crudDocumentsDetailsOperations + `${data.id}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )

    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))
      handleClose()
    }
  }
  const handleTypeDoc = (j) => {
    j.cat
      ? setTypes(typesTemps.filter((el) => (j.id === 5 ? el.domain === j.cat : el.cat === j.cat)))
      : setTypes(typesTemps)
    setValue('Type', '')
    setSelectedTypeDoc(null)
  }
  const handleTypeDocOnly = (j) => {
    console.log(j)
    j.cat
      ? setTypes(typesTemps.filter((el) => (j.id === 5 ? el.domain === j.cat : el.cat === j.cat)))
      : setTypes(typesTemps)
  }
  useEffect(() => {
    handleTypeDocOnly(selectedtypeObj)
  }, [typesTemps])

  return (
    <>
      {/* <ButtonGroup variant="text" aria-label="text button group">
        <Tooltip title="Edit">
          <Button onClick={handleClickOpen}>
            <EditIcon />
          </Button>
        </Tooltip>
      </ButtonGroup> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Éditer Opérations</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            {/* <ComboBox
              handleAutoComplete={(e, j) => setValue('Affectation', j)}
              label="Nom Objet"
              data={accounts}
              name="Affectation"
              selectedValue={a}
              required={true}
            /> */}
            <ComboBox
              handleAutoComplete={(e, j) => {
                handleTypeDoc(j)
                setSelectedtypeObj(j)
                if (j.id === 1) {
                  setValue('Affectation', '')
                  setValue('Vehicules', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('PlanMaintenance', '')
                  setTypeObject(1)
                } else if (j.id === 2) {
                  setValue('PlanMaintenance', '')
                  setValue('Vehicules', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('Immobilier', '')
                  setTypeObject(2)
                } else if (j.id === 3) {
                  setValue('PlanMaintenance', '')
                  setValue('Immobilier', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('Affectation', '')
                  setTypeObject(3)
                } else if (j.id === 4) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('TaskMesToDo', '')
                  setValue('ParcoursPro', '')
                  setTypeObject(4)
                } else if (j.id === 5) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('TaskMesToDo', '')
                  setTypeObject(5)
                } else if (j.id === 6) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('ParcoursPro', '')
                  setTypeObject(6)
                } else if (j.id === 7) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setTypeObject(7)
                }
              }}
              label="Type d’objet"
              data={typeObj}
              name="TypeObj"
              required={true}
              selectedValue={selectedtypeObj}
            />
            {typeObject === 1 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('Immobilier', j)
                  setSelectedImmobilier(j)
                }}
                label="Immobilier"
                data={immobiliers}
                name="Immobilier"
                required={true}
                selectedValue={selectedImmobilier}
              />
            ) : (
              ''
            )}
            {typeObject === 2 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('Affectation', j)
                  setSelectedAccount(j)
                }}
                label="Nom Objet"
                data={accounts}
                name="Affectation"
                required={true}
                selectedValue={selectedAccount}
              />
            ) : (
              ''
            )}

            {typeObject === 3 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('Vehicules', j)
                  setSelectedVehicule(j)
                }}
                label="Véhicules"
                data={vehicules}
                name="Vehicules"
                required={true}
                selectedValue={selectedVehicule}
              />
            ) : (
              ''
            )}
            {typeObject === 4 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('PlanMaintenance', j)
                  setSelectedPlanMaintence(j)
                }}
                label="Plan de maintenance "
                data={planMaintenance}
                name="PlanMaintenance"
                required={true}
                selectedValue={selectedPlanMaintence}
              />
            ) : (
              ''
            )}
            {typeObject === 5 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('ParcoursPro', j)
                  setSelectedParcoursPro(j)
                }}
                label="Parcours Pro "
                data={parcoursPro}
                name="ParcoursPro"
                required={true}
                selectedValue={selectedParcoursPro}
              />
            ) : (
              ''
            )}
            {typeObject === 6 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('TaskMesToDo', j)
                  setSelectedTasks(j)
                }}
                label="Tasks (MesToDo) "
                data={tasks}
                name="TaskMesToDo"
                required={true}
                selectedValue={selectedTasks}
              />
            ) : (
              ''
            )}
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Type', j)
                setSelectedTypeDoc(j)
              }}
              label="Type de document"
              data={types}
              name="Type"
              required={true}
              selectedValue={selectedTypeDoc}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Description"
              label="Description"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Externe"
              label="N° Externe"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Datedéchéance"
              label="Datedéchéance"
            />
            {/* <Link href={f}>{f.split('/').pop()}</Link> */}
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                id="fileInput"
                // accept="application/pdf"
                onChange={(e) => {
                  setFile(e.target.files[0])
                  console.log(e.target.files[0].name)
                }}
              />
            </Button>
            <Box>{file ? file.name : f.replace(/^.*(\\|\/|\:)/, '')}</Box>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Mettre à jour</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
